import styled from "styled-components";
import colors from "../config/colors";
import media from "../config/mediaQueries";

export default styled.section`
  width: 100%;
  background: ${({ color = colors.white }) => color};
  padding: 3rem 2rem;
  ${media.desktop`
    padding: 3rem 4rem;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/ContentSection.js